import { createAction, props } from '@ngrx/store';
import { SelectItem } from 'primeng/api';
import { PagingResultsModel } from '../../../models/pagingResultsModel';
import { FormError } from '../../../models/utilModels';
import { FormApprovalQueueModel, HrEmployeeChangeQueueModel } from '../../../models/queueModels';
import { EmployeeReferralModel, EmployeeReferralQueueModel, MyEmployeeReferralModel } from '../../../models/employeeReferralModel';
import { ProspectiveCandidateModel } from '../../../models/prospectiveCandidateModel';


export const loadFormApprovalFormList = createAction('[Queues] Load Form Approval Form List');
export const loadFormApprovalFormListSuccess = createAction('[Queues] Load Form Approval Form List Success',
  props<{ formList: SelectItem[] }>());

export const getFormApprovalQueue = createAction('[Queues] Get Form Approval Queue',
  props<{ filter: any }>());
export const getFormApprovalQueueSuccess = createAction('[Queues] Get Form Approval Queue Success',
  props<{ list: PagingResultsModel<FormApprovalQueueModel> }>());

export const approveFormSubmission = createAction('[Queues] Approve Form Submission', props<{ formSubmissionId: number }>());
export const approveFormSubmissionSuccess = createAction('[Queues] Approve Form Submission Success');
export const approveFormSubmissionFailure = createAction('[Queues] Approve Form Submission Failure');

export const getUploadDocApprovalCount = createAction('[Queues] Get Upload Doc Approval Count');
export const getUploadDocApprovalCountSuccess = createAction('[Queues] Get Upload Doc Approval Count Success',
  props<{ count: number }>());

export const getFormApprovalCount = createAction('[Queues] Get Form Approval Count');
export const getFormApprovalCountSuccess = createAction('[Queues] Get Form Approval Count Success',
  props<{ count: number }>());

export const getHrEmployeeChangeQueue = createAction('[Queues] Get HR Employee Change Queue',
  props<{ filter: any }>());
export const getHrEmployeeChangeQueueSuccess = createAction('[Queues] Get HR Employee Change Queue Success',
  props<{ list: PagingResultsModel<HrEmployeeChangeQueueModel> }>());

export const getHrEmployeeChangeCount = createAction('[Queues] Get HR Employee Change Count');
export const getHrEmployeeChangeCountSuccess = createAction('[Queues] Get HR Employee Change Count Success',
  props<{ count: number }>());

export const dismissHrEmployeeChange = createAction('[Queues] Dismiss HR Employee Change',
  props<{ notificationId: number }>());
export const dismissHrEmployeeChangeSuccess = createAction('[Queues] Dismiss HR Employee Change Success');
export const dismissHrEmployeeChangeFailure = createAction('[Queues] Dismiss HR Employee Change Failure');

export const showEditEmployeeReferral = createAction('[Queues] Show Edit Employee Referral Modal',
  props<{ referralId: number, prospectiveCandidate: ProspectiveCandidateModel }>());
export const closeEditEmployeeReferral = createAction('[Queues] Close Edit Employee Referral Modal');

export const getEmployeeReferral = createAction('[Queues] Get Employee Referral',
  props<{ referralId: number }>());
export const getEmployeeReferralSuccess = createAction('[Queues] Get Employee Referral Success',
  props<{ referral: EmployeeReferralModel }>());
export const getEmployeeReferralFailure = createAction('[Queues] Get Employee Referral Failure',
  props<{ err: any }>());

export const saveEmployeeReferral = createAction('[Queues] Save Employee Referral',
  props<{ referral: EmployeeReferralModel }>());
export const saveEmployeeReferralSuccess = createAction('[Queues] Save Employee Referral Success');
export const saveEmployeeReferralFailure = createAction('[Queues] Save Employee Referral Failure',
  props<{ err: any }>());

export const getEmployeeReferralList = createAction('[Queues] Get Employee Referral List', props<{ filter: any }>());
export const getEmployeeReferralListSuccess = createAction('[Queues] Get Employee Referral List Success',
  props<{ referralList: PagingResultsModel<EmployeeReferralQueueModel> }>());

export const createReferralFormSubmission = createAction('[Queues] Create Referral Form Submission ',
  props<{ referralId: number }>());
export const createReferralFormSubmissionSuccess = createAction('[Queues] Create Referral Form Submission Success');
export const createReferralFormSubmissionFail = createAction('[Queues] Create Referral Form Submission Fail',
  props<{ err: any }>());

export const awardReferralBonus = createAction('[Queues] Award Referral Bonus ',
  props<{ referralId: number }>());
export const awardReferralBonusSuccess = createAction('[Queues] Award Referral Bonus Success');
export const awardReferralBonusFail = createAction('[Queues] Award Referral Bonus Fail',
  props<{ err: any }>());

export const recalculateReferralBonus = createAction('[Queues] Recalculate Referral Bonus',
  props<{ payrollBonusId: number }>());
export const recalculateReferralBonusSuccess = createAction('[Queues] Recalculate Referral Bonus Success');
export const recalculateReferralBonusFail = createAction('[Queues] Recalculate Referral Bonus Fail',
  props<{ err: any }>());

export const deleteReferralBonus = createAction('[Queues] Delete Referral Bonus',
  props<{ payrollBonusId: number }>());
export const deleteReferralBonusSuccess = createAction('[Queues] Delete Referral Bonus Success');
export const deleteReferralBonusFail = createAction('[Queues] Delete Referral Bonus Fail',
  props<{ err: any }>());

export const toggleArchiveEmployeeReferral = createAction('[Queues] Toggle Archive Employee Referral',
  props<{ referralId: number, reason: string }>());
export const toggleArchiveEmployeeReferralSuccess = createAction('[Queues] Toggle Archive Employee Referral Success');
export const toggleArchiveEmployeeReferralFail = createAction('[Queues] Toggle Archive Employee Referral Fail',
  props<{ err: any }>());

export const deleteEmployeeReferral = createAction('[Queues] Delete Employee Referral',
  props<{ referralId: number }>());
export const deleteEmployeeReferralSuccess = createAction('[Queues] Delete Employee Referral Success');
export const deleteEmployeeReferralFail = createAction('[Queues] Delete Employee Referral Fail',
  props<{ err: any }>());

export const getMyReferrals = createAction('[Queues] Get My Employee Referrals', props<{ filter: any }>());
export const getMyReferralsSuccess = createAction('[Queues] Get My Employee Referrals Success',
  props<{ referralList: PagingResultsModel<MyEmployeeReferralModel> }>());

export const rejectEmployeeReferral = createAction('[Queues] Reject Employee Referral',
  props<{ referralId: number, reason: string }>());
export const rejectEmployeeReferralSuccess = createAction('[Queues] Reject Employee Referral Success');
export const rejectEmployeeReferralFail = createAction('[Queues] Reject Employee Referral Fail',
  props<{ err: any }>());

export const resetEmployeeReferral = createAction('[Queues] Reset Employee Referral',
  props<{ referralId: number }>());
export const resetEmployeeReferralSuccess = createAction('[Queues] Reset Employee Referral Success');
export const resetEmployeeReferralFail = createAction('[Queues] Reset Employee Referral Fail',
  props<{ err: any }>());
